export const FORCE_PASSWORD_CHANGE_EVENT = "surfside:force-password-change";